import React from 'react';

import LinearGradient from 'react-native-linear-gradient';

import { blackTransparent } from 'utils/colors';

import styles from './styles';

const colors = [
    blackTransparent(1),
    blackTransparent(0.5),
    blackTransparent(0),
];
const horizontalGradient = {
    colors,
    start: { x: 0, y: 0 },
    end: { x: 1, y: 0 },
    locations: [0, 0.5, 1],
};

export const verticalGradient = {
    colors: [
        blackTransparent(0.99),
        blackTransparent(0.96),
        blackTransparent(0.91),
        blackTransparent(0.85),
        blackTransparent(0.76),
        blackTransparent(0.66),
        blackTransparent(0.557),
        blackTransparent(0.44),
        blackTransparent(0.33),
        blackTransparent(0.23),
        blackTransparent(0.14),
        blackTransparent(0.08),
        blackTransparent(0.03),
        blackTransparent(0.008),
        blackTransparent(0),
    ],
    opaque: { x: 0, y: 1 },
    translucent: { x: 0, y: 0 },
    locations: [
        0.06, 0.13, 0.2, 0.26, 0.33, 0.4, 0.46, 0.53, 0.6, 0.66, 0.73, 0.8,
        0.86, 0.93, 1,
    ],
};

const Gradient = () => (
    <>
        <LinearGradient
            style={styles.topLinerGradient}
            start={verticalGradient.translucent}
            end={verticalGradient.opaque}
            locations={verticalGradient.locations}
            colors={verticalGradient.colors}
            pointerEvents="none"
        />
        <LinearGradient
            style={styles.leftLinerGradient}
            start={horizontalGradient.start}
            end={horizontalGradient.end}
            locations={horizontalGradient.locations}
            colors={horizontalGradient.colors}
            pointerEvents="none"
        />
        <LinearGradient
            style={styles.bottomLinerGradient}
            start={verticalGradient.opaque}
            end={verticalGradient.translucent}
            colors={verticalGradient.colors}
            pointerEvents="none"
        />
    </>
);

export default Gradient;
